/* See src/components/lightbox.scss for usage */

jQuery(document).ready(function() {
	insertLbCode();
	attachLightBox();
});

function insertLbCode() {
	var html = "<div class=\"lb_background\"></div><div class=\"lb_core\"><div class=\"lb_inner\"></div><div class=\"lb_close\"><img src=\"img/icons/close.png\" /></div></div>";
	$('body').append(html);
}
function attachLightBox() {
	$('.lb-trigger').on('click', function(e) {
		e.preventDefault();
		var source = $(this).data('source');
		var source_type = $(this).data('source_type');
		var html = "";
		switch(source_type) {
			case "link":
				html = $(source).html();
				break;
			case "youtube":
				html = '<div class="video-wrapper"><iframe src="//players.brightcove.net/2574028764001/SykGTiz2b_default/index.html?videoId=' + source + '" allowfullscreen webkitallowfullscreen mozallowfullscreen allow="encrypted-media"></iframe></div>';
				break;
			case "image":
			case "img":
				html = '<div class="image-wrapper"><img src="' + source + '" /></div>';
				break;
			default:
				html = source;
				break;
		}
		showLightBox(html);
		return false;
	});

	$('.lb_background, .lb_close').on('click', function() {
		hideLightBox();
	});
}

function showLightBox(source) {
	showLBBackground();
	$('.lb_inner').html(source);
	$('.lb_core').show();
}
function showLBBackground() {
	$('.lb_background').show();
}
function hideLightBox() {
	$('.lb_inner').html('');
	$('.lb_core').hide();
	$('.lb_background').hide();
}